import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

// Debug log to see what API URL is being used
console.log('API_BASE_URL:', API_BASE_URL);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export const API_ENDPOINTS = {
  ONLINE_PLAYERS: '/api/online-players',
  GAME_REQUESTS: '/api/game-requests',
  QUIZ_QUESTIONS: '/api/quiz/questions',
  DEBUG: '/api/debug/online-players'
};
// Auth interceptor (dual-mode): attaches Bearer token when present AND legacy x-user-* headers,
// without overriding headers a call already set. Only applied to our own API.
const isOwnApi = (url = '') => {
  if (!/^https?:\/\//i.test(url)) return true;
  return url.startsWith(API_BASE_URL) || url.startsWith(window.location.origin);
};

axios.interceptors.request.use((config) => {
  try {
    const full = config.baseURL ? `${config.baseURL}${config.url || ''}` : config.url;
    if (!isOwnApi(full)) return config;
    const setIfMissing = (k, v) => {
      if (v && !config.headers.has(k)) config.headers.set(k, v);
    };
    const token = localStorage.getItem('authToken');
    // While impersonating, the stored token belongs to the original user; rely on legacy headers.
    if (token && localStorage.getItem('isImpersonating') !== 'true') {
      setIfMissing('Authorization', `Bearer ${token}`);
    }
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user) {
      setIfMissing('x-user-id', String(user._id || user.id || ''));
      setIfMissing('x-user-role', user.role);
      setIfMissing('x-user-name', encodeURIComponent(user.name || user.email || ''));
      setIfMissing('x-user-class', user.class);
    }
  } catch (e) { /* never block a request because of the interceptor */ }
  return config;
});
